import { useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge, Nav, Button, Alert, Modal } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL, STUDENTQUEREY, CONTACTMESSAGE } from "../../../API/API";
import "./Content.css";
import { FaEnvelope, FaEye, FaTrash, FaReply } from "react-icons/fa6";
import ResponsMessage from "./ResponsMessage";
import { toast } from "react-toastify";

export default function Messages() {
  const [key, setKey] = useState("student-messages");
  const [studentMessages, setStudentMessages] = useState([]);
  const [contactMessages, setContactMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [selectedMessageId, setSelectedMessageId] = useState(null);

  const fetchMessages = useCallback(async () => {
    setLoading(true);
    try {
      if (key === "student-messages") {
        const res = await axiosPrivate.post(`${baseURL}/${STUDENTQUEREY}`, {
          page: 1,
          limit: 100,
        });
        setStudentMessages(res.data?.data || []);
      } else if (key === "contact-messages") {
        const res = await axiosPrivate.post(`${baseURL}/${CONTACTMESSAGE}`, {
          page: 1,
          limit: 100,
        });
        setContactMessages(res.data?.data || []);
      }
    } catch (error) {
      console.error("خطأ في جلب الرسائل:", error);
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, key]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const handleReply = (messageId) => {
    setSelectedMessageId(messageId);
    setShowResponseModal(true);
  };

  const handleRefreshMessages = () => {
    fetchMessages();
  };

  const handleDeleteMessage = async (messageId) => {
    if (window.confirm("هل أنت متأكد من رغبتك في حذف هذه الرسالة؟")) {
      try {
        // يمكنك أن تضيف endpoint حذف الرسائل هنا
        // حالياً سيتم تحديث القائمة فقط
        const newMessages = key === "student-messages" 
          ? studentMessages.filter(msg => msg.id !== messageId)
          : contactMessages.filter(msg => msg.id !== messageId);
        
        if (key === "student-messages") {
          setStudentMessages(newMessages);
        } else {
          setContactMessages(newMessages);
        }
        
        toast.success("تم حذف الرسالة بنجاح");
      } catch (error) {
        console.error("خطأ في حذف الرسالة:", error);
        toast.error("فشل حذف الرسالة");
      }
    }
  };

  const renderMessages = () => {
    const messages = key === "student-messages" ? studentMessages : contactMessages;

    if (loading) {
      return <Alert variant="info">جاري التحميل...</Alert>;
    }

    if (messages.length === 0) {
      return <Alert variant="warning">لا توجد رسائل</Alert>;
    }

    return (
      <div className="messages-container">
        {messages.map((msg, idx) => (
          <Card key={idx} className="mb-3">
            <Card.Body>
              <Row>
                <Col md={9}>
                  <Card.Title className="d-flex align-items-center gap-2">
                    <FaEnvelope />
                    {msg.name || msg.student_name}
                  </Card.Title>
                  <Card.Subtitle className="text-muted mb-2">
                    البريد: {msg.email || msg.student_email}
                  </Card.Subtitle>
                  <Card.Text>{msg.message}</Card.Text>
                  {msg.status && (
                    <Badge bg={msg.status === "read" ? "success" : "warning"}>
                      {msg.status === "read" ? "مقروءة" : "جديدة"}
                    </Badge>
                  )}
                </Col>
                <Col md={3} className="text-end">
                  <Button
                    variant="outline-info"
                    size="sm"
                    className="me-2"
                    onClick={() => {
                      setSelectedMessage(msg);
                      setShowPreviewModal(true);
                    }}
                  >
                    <FaEye /> عرض
                  </Button>
                  <Button 
                    variant="outline-primary" 
                    size="sm" 
                    className="me-2"
                    onClick={() => handleReply(msg.id)}
                  >
                    <FaReply /> رد
                  </Button>
                  <Button 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => handleDeleteMessage(msg.id)}
                  >
                    <FaTrash /> حذف
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </div>
    );
  };

  return (
    <Container fluid className="p-4">
      <h2 className="mb-4">
        <FaEnvelope className="me-2" /> الرسائل
      </h2>

      <Nav fill variant="tabs" className="mb-4" activeKey={key} onSelect={(k) => setKey(k)}>
        <Nav.Item>
          <Nav.Link eventKey="student-messages">رسائل الطلاب</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="contact-messages">رسائل التواصل</Nav.Link>
        </Nav.Item>
      </Nav>

      {renderMessages()}

      {showPreviewModal && (
        <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} centered>
          <Modal.Header>
            <Modal.Title>تفاصيل الرسالة</Modal.Title>
            <Button variant="danger" onClick={() => setShowPreviewModal(false)} className="ms-2">×</Button>
          </Modal.Header>
          <Modal.Body>
            {selectedMessage ? (
              <div style={{ direction: "rtl" }}>
                <p><strong>الاسم:</strong> {selectedMessage.name || selectedMessage.student_name}</p>
                <p><strong>البريد:</strong> {selectedMessage.email || selectedMessage.student_email}</p>
                <p><strong>الرسالة:</strong></p>
                <p>{selectedMessage.message}</p>
              </div>
            ) : (
              <div>لا توجد رسالة</div>
            )}
          </Modal.Body>
        </Modal>
      )}

      {/* مكون الرد على الرسالة */}
      <ResponsMessage 
        setmessage={setShowResponseModal}
        message={showResponseModal}
        selectId={selectedMessageId}
        onSuccess={handleRefreshMessages}
      />
    </Container>
  );
}
